import { StayExtensionType, isArrival } from './stayExtensionTypes';
import { StayExtensionText } from '../i18n/pages/stayExtension';

/**
 * The short name for one product at one end: on chips, on strips, on action buttons.
 *
 * <p>Pulled out of {@link ../components/StayExtensionGuestSection} so it can be unit tested
 * without dragging in that file's API module (and, transitively, axios — which this project's
 * Jest/CRA setup cannot parse as an ES module, unrelated to this fix).
 *
 * <p>Luggage drop-off and pick-up used to collapse onto the same {@code t.chipBags} label here,
 * leaving only a 0.72rem arrow glyph to tell a host which product a chip or strip referred to —
 * reported as two apartments showing indistinguishable "Bags" chips with opposite, confusing time
 * ranges. Each luggage product now gets its own short label, the same way check-in and check-out
 * already do.
 */
export const stayExtensionChipLabel = (type: StayExtensionType, t: StayExtensionText) => {
  if (type === 'LUGGAGE_DROPOFF') return t.chipLuggageDropoff;
  if (type === 'LUGGAGE_PICKUP') return t.chipLuggagePickup;
  return isArrival(type) ? t.chipCheckin : t.chipCheckout;
};
